/**
 * Extract properties from each step
 * @param {ExtractedTimelineDataProps} timeline
 * @returns {ExtractedStepsDataProps}
 */
const extractSteps = (timeline) => {
  const result = [];

  /** @type {Map<Number, any>} */
  const steps = timeline.get("steps");

  /** Single step. @example {'original' => 'o(1<duration˸2s>)'} */
  for (const step of steps.values()) {
    step.set("common-options", timeline.get("options"));
    step.set("timeline-type", timeline.get("type"));

    result.push(step);
  }

  return result;
};

export default extractSteps;
